import { Component, Input } from '@angular/core';

@Component({
    selector: 'sume-layout-container-card',
    templateUrl: './container-card.component.html',
    styleUrls: ['./container-card.component.scss'],
    styles: [
        `
            .card {
                position: relative;
            }
        `,
    ],
})
export class ContainerCardComponent {
    @Input() card_title;
}
